import type { OrchestrationThread, OrchestrationThreadTimelineWindow } from "@t3tools/contracts";
import * as Option from "effect/Option";

export type EnvironmentThreadStatus = "empty" | "cached" | "synchronizing" | "live" | "deleted";

export interface EnvironmentThreadState {
  readonly data: Option.Option<OrchestrationThread>;
  /** Current process/connection timeline window. Never persisted. */
  readonly timeline: Option.Option<OrchestrationThreadTimelineWindow>;
  readonly status: EnvironmentThreadStatus;
  readonly error: Option.Option<string>;
  /** Live subscription data. Never loaded from or written to EnvironmentCacheStore. */
  readonly workingStatus: string | null;
}

export const EMPTY_ENVIRONMENT_THREAD_STATE: EnvironmentThreadState = {
  data: Option.none(),
  timeline: Option.none(),
  status: "empty",
  error: Option.none(),
  workingStatus: null,
};
